import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Drawer from "../Drawer";
import IconView from "../IconView/IconView";
import ReactSelect from "../ReactSelect/ReactSelect";
import descriptionStyle from "../../../constants/descriptionStyle.json";
import _ from "lodash";
import { getImageUrl } from "Common/utils/ImageDomain";
import { showNotification } from "Common/utils/Notification";
import Button from "../ButtonComponent/Button";
import ImageData from "../customImage/ImageSegment";
import ImageView from "../ImageView/ImageView";
import { X } from "lucide-react";
import ExperienceSegmentCard from "../ExperienceSegmentCard";
import CustomInput from "../InputFields/CustomInput";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
/* 
{
  "header_text": "",
  "subheader_text": "",
  "view_url": "",
  "segments": [{ icon: "", description: "" }]
}
*/

const ExperienceSegment = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentType,
  toggleVisiblity,
  segmentId,
}) => {
  const segment = data?.cards ? data?.cards : [];
  const [styleType, setStyleType] = useState("");
  const [saticStyle, setStaticStyle] = useState<any>();
  const [segments, setSegments] = useState(segment);
  const [headerText, setHeaderText] = useState(
    data?.header_text ? data?.header_text : ""
  );
  const [subHeaderText, setSubHeaderText] = useState(
    data?.sub_header_text ? data?.sub_header_text : ""
  );
  const [isLoading, setIsLoading] = useState<any>(false);
  const [eventData, setEventData] = useState<any>();
  const [showVideo, setShowVideo] = useState(false);
  const [index, setIndex] = useState(undefined);
  const [errors, setErrors] = useState<any>({
    segments: segments?.map(() => ({
      description: "",
      header_text: "",
    })),
  });
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [backgroundImage, setBackgroundImage] = useState<any>(
    data?.background_image ? data?.background_image : ""
  );
  const [backgroundImageId, setBackgroundImageId] = useState<any>("");
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>(
    data?.mobile_background_image_id
  );
  const [indexBack, setIndexBack] = useState(undefined);

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "image") {
        if (indexBack === undefined) {
          setBackgroundImage(imageData.media_url);
          setBackgroundImageId(imageData._id);
          setErrors((prev) => ({ ...prev, ["background_image"]: "" }));
        } else if (indexBack === "background") {
          setMobileBackground(imageData.media_url);
          setMobileBackgroundId(imageData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [imageData, indexBack]);

  const toggle = () => setShowVideo(!showVideo);
  useEffect(() => {
    if (eventData && eventData.icon_url) {
      handleSegmentInputChange(index, "icon", eventData.icon_url);
    }
  }, [eventData, index]);

  useEffect(() => {
    if (data && data?.style) {
      setStaticStyle({ label: data?.style, value: data?.style });
      setStyleType(data?.style);
    }
  }, [data]);

  const addSegment = () => {
    setSegments([...segments, { icon: "", description: "", header_text: "" }]);
    setErrors({
      ...errors,
      segments: [...errors.segments, { description: "", header_text: "" }],
    });
  };
  const handleStyleData = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
      setStyleType("");
    } else {
      setStyleType(keyValue.value);
    }
    setStaticStyle(keyValue);
  };
  const removeSegment = (index) => {
    const updatedSegments = segments.filter((_, i) => i !== index);
    setSegments(updatedSegments);

    const updatedErrors = { ...errors };
    updatedErrors.segments.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleSegmentInputChange = (index, field, value) => {
    const updatedButtons = segments.map((button, i) => {
      if (i === index) {
        button[field] = value;
      }
      return button;
    });
    setSegments(updatedButtons);

    const updatedErrors = { ...errors };
    if (updatedErrors.segments[index]) {
      updatedErrors.segments[index][field] = "";
    }
    setErrors(updatedErrors);
  };
  const handleRemoveIcon = (index) => {
    setSegments((prevSegments) =>
      prevSegments.map((segment, i) =>
        i === index ? { ...segment, icon: "" } : segment
      )
    );
  };
  const handleSave = async (pageId, id) => {
    const newErrors = {
      segments: segments?.map(() => ({
        description: "",
        header_text: "",
      })),
    };

    segments?.forEach((award, index) => {
      if (!award.description?.trim()) {
        newErrors.segments[index].description = "Description is required.";
      }
      if (!award.header_text?.trim()) {
        newErrors.segments[index].header_text = "Header text is required.";
      }
      // if (!award.icon_id?.trim()) {
      //   newErrors.segments[index].icon_id = "Icon Id is required.";
      // }
    });

    setErrors(newErrors);

    if (
      newErrors?.segments?.every(
        (error) => !error.description && !error.header_text
      )
    ) {
      const payload = {
        segment_type: "experience_segments",
        header_text: headerText,
        sub_header_text: subHeaderText,
        style: styleType,
        cards: segments,

        background_image: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImage,
        background_image_id: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImageId,
        mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground,
        mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
      };

      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Experience Segment saved successfully!", "success");
        } else {
          showNotification("Something went wrong. Please try again.", "error");
        }
      } catch (e) {
        showNotification("An error occurred . Please try again.", "error");
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        {/* Header Text */}
        <div className="xl:col-span-12">
          <CustomInput
            label="Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Header Text"
            value={headerText}
            onChange={(e) => {
              setHeaderText(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.header_text}
          />
        </div>
        <div className="xl:col-span-12">
          <CustomInput
            label="Sub Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Sub Header Text"
            value={subHeaderText}
            onChange={(e) => {
              setSubHeaderText(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.subheader_text}
          />
        </div>
        <div>
          <div className="flex my-4">
            {backgroundImage ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={backgroundImage}
                  setImageData={setImageData}
                  setImageLink={setBackgroundImage}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack(undefined);
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack(undefined);
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setImageData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack("background");
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack("background");
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add MobileBackground
              </button>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="mb-4 xl:col-span-6">
            <label className="inline-block mb-2 text-base font-medium">
              Style
            </label>
            <ReactSelect
              options={descriptionStyle}
              isSearchable={false}
              isMulti={false}
              placeholder={"Please select style type"}
              contentType={saticStyle}
              handleContentChange={handleStyleData}
              name={"style"}
              id={"style-type2"}
              versionData={{
                label: versionData?.style,
                value: versionData?.style,
              }}
            />
          </div>
        </div>
        <div className="flex justify-end my-4">
          <button
            onClick={addSegment}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Add experience
          </button>
        </div>

        {versionData?.cards?.length > 0 && <p>Old Data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Segments */}
          {versionData?.cards?.length > 0 &&
            versionData?.cards?.map((award, index) => (
              <div className="py-4 xl:col-span-4">
                <ExperienceSegmentCard
                  key={index}
                  index={index}
                  award={award}
                  handleSegmentInputChange={handleSegmentInputChange}
                  errors={errors}
                  removeSegment={removeSegment}
                  isEditable={false}
                  getImageUrl={getImageUrl}
                  handleRemoveIcon={handleRemoveIcon}
                  toggle={toggle}
                  setIndex={setIndex}
                  setEventData={setEventData}
                  pageId={pageId}
                  segmentId={segmentId}
                />
              </div>
            ))}
        </div>
        {segments?.length > 0 && <p>New Data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Segments */}
          {segments?.map((award, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <ExperienceSegmentCard
                key={index}
                index={index}
                award={award}
                handleSegmentInputChange={handleSegmentInputChange}
                errors={errors}
                removeSegment={removeSegment}
                isEditable={true}
                getImageUrl={getImageUrl}
                handleRemoveIcon={handleRemoveIcon}
                toggle={toggle}
                setIndex={setIndex}
                setEventData={setEventData}
                pageId={pageId}
                segmentId={segmentId}
              />
            </div>
          ))}
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showVideo}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Icon"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <IconView
            showImage={showVideo}
            setEventData={setEventData}
            togleImage={toggle}
          />
        </Drawer.Body>
      </Drawer>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default ExperienceSegment;
